import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import Header2 from "../../components/header/Header2";
import Category10 from "../../components/category/Category10";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons
import Breadcrumb from "../../components/breadcrumb";
import StepProgress from "../../components/StepProgress";

Planner.propTypes = {};

function Planner(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
  const [categoriesnew2, setCategoriesnew2] = useState([]);

  // near other useState declarations
  const [bookingLoading, setBookingLoading] = useState(false);
  const [bookingError, setBookingError] = useState(null);
  const [bookingSuccess, setBookingSuccess] = useState(null);
  const [customerName, setCustomerName] = useState(""); // optional: collect from user (or get from auth)
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
    fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort");
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort");
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort");
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

  const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort");
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { id, category } = useParams();

  const [datanew, setDatanew] = useState([]);


useEffect(() => {
  if (!category) return;

  const allowedCategories = [
    "Personalised Consultation",
    "Tarot Card Reading",
    "Palmistry",
    "Numerology",
    "Face Reading",
    "Handwriting Analysis",
    "Signature Analysis",
    "Vastu Analysis",
  ];

  const normalizedCategory = category.trim().toLowerCase();

  // --- NEW: Handle Birth Time Rectification separately ---
  if (normalizedCategory === "birth time rectification") {
    navigate(`/plannerbtr/${id}/${encodeURIComponent(category)}`, {
      replace: true,
    });
    return;
  }

  if (normalizedCategory === "hand made kundali report") {
    navigate(`/plannerhmkr/${id}/${encodeURIComponent(category)}`, {
      replace: true,
    });
    return;
  }

  // --- Existing: allowedCategories logic ---
  const isAllowed = allowedCategories.some(
    (c) => c.toLowerCase() === normalizedCategory
  );

  if (!isAllowed) {
    navigate(`/plannerwithouttopics/${id}/${encodeURIComponent(category)}`, {
      replace: true,
    });
  }
}, [category, id, navigate]);






  useEffect(() => {
    const fetchAstrologerDetails = async () => {
      try {
        const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrologer/${id}`);
        setDatanew(response.data); // Assuming response contains Named, Path1, Fdesc
      } catch (error) {
        console.error("Error fetching astrologer details:", error);
      }
    };

    fetchAstrologerDetails();
  }, [id]);

  const [topics, setTopics] = useState([]);
  const [selectedTopics, setSelectedTopics] = useState([]);
  // add with other useState declarations
  const [floatingOpen, setFloatingOpen] = useState(false);

  // --- PERSISTENCE: storage key per planner page (scoped to astrologer id + category)
  const storageKey = `plannerState_${id ?? "unknown"}_${category ?? "unknown"}`;
const [language, setLanguage] = useState("en");

  // fetch topics on mount
  useEffect(() => {
    if (!category) return;
    const fetchTopics = async () => {
      try {
        const resp = await axios.get(
          `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrotopics-by-category/${encodeURIComponent(category)}`
        );
        setTopics(resp.data || []);
      } catch (err) {
        console.error("Error fetching topics:", err);
      }
    };

    fetchTopics();
  }, [category]);

  

  // restore saved planner state (run after topics load)
  useEffect(() => {
    if (!topics || topics.length === 0) return;

    try {
      const raw = localStorage.getItem(storageKey);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.selectedTopics)) return;

      // keep only topic IDs that still exist in `topics`
      const availableIds = new Set(topics.map((t) => t.Id));
      const restored = parsed.selectedTopics.filter((tid) => availableIds.has(tid));

      if (restored.length > 0) {
        setSelectedTopics(restored);
      } else {
        // nothing to restore — leave as empty
      }
    } catch (e) {
      console.warn("Failed to restore planner state:", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topics, storageKey]);

  // clear persisted state on success (optional but recommended)
  useEffect(() => {
    if (bookingSuccess) {
      try {
        localStorage.removeItem(storageKey);
      } catch (e) {
        // ignore
      }
    }
  }, [bookingSuccess, storageKey]);

  // Plans state
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    if (!id || !category) return;

    const fetchPlans = async () => {
      try {
        const resp = await axios.get(
          `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/api/astroplans/${encodeURIComponent(
            id
          )}/${encodeURIComponent(category)}`
        );
        // normalize Mint/Maxt to integers for safety
        const normalized = (resp.data || []).map((p) => ({
          ...p,
          Mint: p.Mint !== null && p.Mint !== undefined ? parseInt(p.Mint, 10) : 0,
          Maxt: p.Maxt !== null && p.Maxt !== undefined ? parseInt(p.Maxt, 10) : 0,
          addonPrice: Number(p.addonPrice ?? 0),
          basePrice: Number(p.basePrice ?? 0),
          totalPrice: Number(p.totalPrice ?? (Number(p.basePrice ?? 0) + Number(p.addonPrice ?? 0))),
        }));
        setPlans(normalized);
      } catch (err) {
        console.error("Error fetching astroplans:", err);
        setPlans([]);
      }
    };

    fetchPlans();
  }, [id, category]);

  // Derived values
  const selectedCount = selectedTopics.length;

  // global maximum allowed topics: maximum Maxt across all plans (0 if no plans)
  const globalMax = useMemo(() => {
    if (!plans || plans.length === 0) return 0;
    return Math.max(...plans.map((p) => Number(p.Maxt) || 0));
  }, [plans]);

  // For each plan, remaining allowed selections to reach Maxt
  const plansWithRemaining = useMemo(() => {
    return plans.map((p) => {
      const maxt = Number(p.Maxt) || 0;
      const mint = Number(p.Mint) || 0;
      const remainingToMax = Math.max(0, maxt - selectedCount);
      const remainingToMin = Math.max(0, mint - selectedCount);
      return {
        ...p,
        remainingToMax,
        remainingToMin,
        isAutoSelected: selectedCount >= mint && selectedCount <= maxt,
      };
    });
  }, [plans, selectedCount]);

  // Prevent additional selection if globalMax reached
  const isGlobalMaxReached = globalMax > 0 && selectedCount >= globalMax;

  // choose a single "best" chosen plan to display above topics:
  // - pick an auto-selected plan (isAutoSelected === true)
  // - if multiple, choose the one with the smallest remainingToMax (closest to filling)
  const chosenPlan = useMemo(() => {
    const auto = plansWithRemaining.filter((p) => p.isAutoSelected);
    if (!auto || auto.length === 0) return null;
    // pick plan with smallest remainingToMax
    auto.sort((a, b) => a.remainingToMax - b.remainingToMax);
    return auto[0];
  }, [plansWithRemaining]);

  // toggle individual checkbox (prevents adding if globalMax reached)
  const handleSelect = (topicId) => {
    setSelectedTopics((prev) => {
      const already = prev.includes(topicId);
      let newSel;
      if (already) {
        newSel = prev.filter((id) => id !== topicId);
      } else {
        if (isGlobalMaxReached) {
          return prev;
        }
        newSel = [...prev, topicId];
      }
      try {
        localStorage.setItem(storageKey, JSON.stringify({ selectedTopics: newSel }));
      } catch (e) {
        console.warn("Failed to persist planner state", e);
      }
      return newSel;
    });
  };

  // select all toggle — respect globalMax (select up to globalMax)
  const handleSelectAll = () => {
    if (selectedTopics.length === topics.length) {
      const cleared = [];
      setSelectedTopics(cleared);
      try { localStorage.setItem(storageKey, JSON.stringify({ selectedTopics: cleared })); } catch(e){}
      return;
    }
    const limit = globalMax > 0 ? Math.min(topics.length, globalMax) : topics.length;
    const firstN = topics.slice(0, limit).map((t) => t.Id);
    setSelectedTopics(firstN);
    try { localStorage.setItem(storageKey, JSON.stringify({ selectedTopics: firstN })); } catch(e){}
  };

  // UI message shown when user tries to add more but global max reached
  const [userNote, setUserNote] = useState("");
  useEffect(() => {
    if (!globalMax || globalMax === 0) {
      setUserNote("");
      return;
    }
    if (selectedCount > globalMax) {
      setUserNote(`You have exceeded the maximum allowed topics (${globalMax}).`);
    } else if (selectedCount === globalMax) {
      setUserNote(`You have reached the maximum allowed topics for available plans (${globalMax}).`);
    } else {
      setUserNote("");
    }
  }, [selectedCount, globalMax]);

  const handleBook = async (e) => {
    e?.preventDefault?.();
    setBookingError(null);
    setBookingSuccess(null);

    // ✅ Login check
    const userId = localStorage.getItem("userId");
    if (!userId) {
      // store the current page so we can redirect after login
      localStorage.setItem("redirectAfterLogin", window.location.pathname);

      // persist current planner selections explicitly (extra safety)
      try {
        localStorage.setItem(storageKey, JSON.stringify({ selectedTopics }));
      } catch (e) {
        console.warn("Could not persist planner state before redirect:", e);
      }

      navigate("/login");
      return;
    }

    // require at least one topic (button should be disabled already, but double-check)
    if (!selectedTopics || selectedTopics.length === 0) {
      setBookingError("Please choose at least one topic before proceeding.");
      return;
    }

    // ✅ Require a chosen plan and at least one topic
    if (!chosenPlan) {
      setBookingError("Please select a plan (by choosing topics) before booking.");
      return;
    }

    setBookingLoading(true);

    try {
      const payload = {
        astrologerId: id,
        category,
        planId: chosenPlan.planId ?? null,
        totalPrice: Number(chosenPlan.totalPrice ?? 0),
        customerName: `Plan ${chosenPlan.totalPrice}`,
        topics: selectedTopics,
        // add slot/preferredDate here if you collect it
        userId, // ✅ optionally include userId in booking payload if needed
      };

      const resp = await axios.post(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/api/bookings",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (resp?.data?.success && resp?.data?.bookingId) {
        const bookingId = resp.data.bookingId;

        // Optional: show a quick success message before redirecting
        setBookingSuccess(`Plan created successfully (ID: ${bookingId}). Redirecting...`);

        // ---- clear saved planner state BEFORE redirecting to scheduler ----
        try {
          localStorage.removeItem(storageKey);
        } catch (e) {
          console.warn("Failed to clear planner state before redirect:", e);
        }

        // Redirect to scheduler page
        navigate(`/scheduler/${bookingId}`);
      } else {
        setBookingError(resp?.data?.message || "Unexpected server response.");
      }
    } catch (err) {
      console.error("Booking error:", err);
      setBookingError(
        err?.response?.data?.message || err.message || "Failed to create booking."
      );
    } finally {
      setBookingLoading(false);
    }
  };

  // Helper boolean for button disabled state: disabled while loading OR no topics selected
  // This ensures user cannot click to go to login or scheduler until at least one topic is selected.
  const canProceed = selectedTopics && selectedTopics.length > 0 && !bookingLoading;

  return (
    <>
      <Helmet>
        <title>eConsultation Planner - Adhigyanam | Sauntesthyam LLP</title>
      </Helmet>
       <div className="menu-mobile-popup">
              <div className="modal-menu__backdrop" onClick={handleMobile}></div>
              <div className="widget-filter">
                <div className="mobile-header">
                  <div id="logo" className="logo">
                    <Link to="/home">
                      <img className="site-logo" src={logo} alt="Image" />
                    </Link>
                  </div>
                  <Link className="title-button-group" onClick={handleMobile}>
                    <i className="icon-close"></i>
                  </Link>
                </div>

               <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
                <div className="header-customize-item button" style={{padding: "0px 0px",
          background:"none",
          backgroundColor:"#14a077",
          borderRadius: "4px",
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "21px",
          color: "white",
          borderColor: "transparent",
          textTransform: "capitalize"}}>
                  <Link to="/astroservices" style={{color: "#ffffff"}}>Consult Now</Link>
                </div>
                <div className="header-customize-item button">
                  <Link to="/login">My Account</Link>
                </div>

                 <div className="mobile-footer">
                  <div className="icon-infor d-flex aln-center">
                    <div className="icon">
                      <span className="icon-call-calling">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                      </span>
                    </div>
                    <div className="content">
                      <p>Need help? 24/7</p>
                      <h6>
                         <Link to={`tel:918960708425`}>+91-8960708425</Link>
                      </h6>
                    </div>
                  </div>
                  <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
                  <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
                  <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
            <ul className="list-social d-flex aln-center">
                                           <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                           <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                           <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                       </ul>
          </div>
                </div>
              </div>
            </div>
      

       {/* --- Inline page styles for floating collapsible card (page-scoped) --- */}
   <style>{`
  /* Floating Collapsible Card — centered layout */
  .floating-plan-card {
    position: fixed;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    z-index: 1200;
    background: #f6fffb;
    border: 1px solid #bfead2;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    max-width: 360px;
    width: 90%;
    transition: transform 0.25s ease, opacity 0.25s ease;
    overflow: hidden;
    font-family: inherit;
    box-sizing: border-box;
    animation: fadeInUp 0.35s ease;
  }

  /* Inner wrapper */
  .floating-plan-inner { 
    padding: 10px; 
    box-sizing: border-box;
  }

  /* Header row (collapsed view) */
  .floating-header { 
    padding: 6px 4px; 
    display: flex; 
    justify-content: space-between; 
    align-items: center; 
    flex-wrap: nowrap;
  }

  /* Buttons: expand + close */
  .floating-expand-toggle,
  .floating-close-btn {
    background: transparent;
    border: none;
    color: #444;
    font-size: 16px;
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 6px;
    line-height: 1;
  }

  .floating-expand-toggle:hover,
  .floating-close-btn:hover { 
    color: #111; 
  }

  /* Details area - collapsed by default */
  .floating-details {
    max-height: 0;
    opacity: 0;
    transform-origin: top;
    transition: max-height 300ms ease, opacity 300ms ease, transform 300ms ease;
    transform: translateY(-4px);
    overflow: hidden;
  }

  /* Expanded state */
  .floating-plan-card.open .floating-details,
  .floating-details.show {
    max-height: 420px;
    opacity: 1;
    transform: translateY(0);
  }

  /* Optional smaller footprint when closed */
  .floating-plan-card.closed { 
    transform: translateX(-50%) translateY(0); 
  }

  /* Entry animation */
  @keyframes fadeInUp {
    from { transform: translate(-50%, 20px); opacity: 0; }
    to { transform: translate(-50%, 0); opacity: 1; }
  }

  /* ---------------------------------- */
  /* MOBILE STYLES (center stays the same) */
  /* ---------------------------------- */
  @media (max-width: 767.98px) {
    .floating-plan-card {
      bottom: 12px;
      max-width: 96%;
      width: 96%;
      left: 50%;
      transform: translateX(-50%);
      box-sizing: border-box;
    }

    .floating-plan-inner { padding: 10px; }
    .floating-header { padding: 8px 6px; }
    .floating-expand-toggle, 
    .floating-close-btn { font-size: 18px; }
    .floating-header > * { min-width: 0; }
  }
`}</style>

      <Header2 clname="act1" handleMobile={handleMobile} />
      <Breadcrumb title="eConsultation Planner" />
     

      <section className="testimonials-category-section" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
        <div className="tf-container">
          <div className="row">
            <div className="col-md-12">
              <div className="row" style={{ marginBottom: "20px" }}>
                <div className="col-lg-12 col-12" style={{ textAlign: "center" }}>
                  <h5 style={{ marginTop: "10px", marginBottom: "0px", fontSize:"22px" }}>{datanew.Named}</h5>
                  <p style={{ fontStyle: "italic", maxWidth: "650px", padding: "auto", margin: "auto", marginBottom: "5px" }}>
                    <span style={{ color: "#14A078", fontWeight: "bold", fontSize: "17px", fontStyle: "normal" }}>{category} Expert</span>
                  </p>
                   <StepProgress activeStep={1} />
                  {bookingError && <div style={{ color: "#b22222", marginTop: 8 }}>{bookingError}</div>}
{bookingSuccess && <div style={{ color: "#14a077", marginTop: 8 }}>{bookingSuccess}</div>}
                </div>
              </div>
            </div>

            <div className="col-md-10" style={{ margin: "auto" }}>
              <div className="row">
                <div className="col-lg-8 col-md-8 col-12">
                 {/* SHOW CHOSEN PLAN CARD ABOVE TOPICS (left-hand side) */}
                 {/* COLLAPSIBLE FLOATING CHOSEN PLAN */}
{chosenPlan && (
  <div
    className={`floating-plan-card ${floatingOpen ? "open" : "closed"}`}
    role="region"
    aria-label="Selected plan summary" style={{boxShadow: "1px 1px 1px 2px rgba(0, 0, 0, 0.1)"}}
  >
    <div className="floating-plan-inner">
      {/* Header row: minimal bar with toggle */}
       {globalMax > 0 && selectedCount > 0 && (
                    <div style={{ marginTop: 0, color: isGlobalMaxReached ? "#9b2c2c" : "#666", fontSize: 14, marginBottom: 3, paddingLeft:"6px" }}>
                      {isGlobalMaxReached ? (
                        <strong>You have reached the maximum ({globalMax}) topics allowed by available astrologer plans.</strong>
                      ) : (
                        <span style={{fontWeight:"bold"}}>
                          <span style={{color: "#14a077"}}>Selected Topics</span>: <strong>{selectedCount}</strong>
                        </span>
                      )}
                    </div>
                  )}
      <div
        className="floating-header"
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, cursor: "pointer", paddingTop:"0px" }}
        onClick={() => setFloatingOpen((s) => !s)}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") setFloatingOpen((s) => !s); }}
        tabIndex={0}
        role="button"
        aria-expanded={floatingOpen}
      >

        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <div style={{ fontWeight: 800, fontSize: 15, color: "#111" }}>
           <strong>Plan {chosenPlan.totalPrice}</strong> 
          </div>
          <div style={{ fontSize: 13, color: "#444" }}>
             (Topics covered: <strong>{chosenPlan.Maxt ?? "N/A"}</strong>)
          </div>
        </div>

        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <button
            className="floating-expand-toggle" style={{fontSize:"25px"}}
            onClick={(e) => { e.stopPropagation(); setFloatingOpen((s) => !s); }}
            aria-label={floatingOpen ? "Collapse plan details" : "Expand plan details"}
            title={floatingOpen ? "Collapse" : "Expand"}
          >
            {floatingOpen ? "▴" : "▾"}
          </button>
        </div>
      </div>

      {/* Expandable details area */}
      <div className={`floating-details ${floatingOpen ? "show" : ""}`} aria-hidden={!floatingOpen}>
        <div style={{ marginTop: 8, color: "#444", fontSize: 13 }}>
          <div style={{ marginBottom: 0 }}>
            <div style={{ marginTop: 4, color: "#14a077", fontWeight: 800 }}>Consultation Fee: ₹{Number(chosenPlan.totalPrice ?? 0).toFixed(2)}</div>
          </div>

          {chosenPlan.remainingToMax > 0 && (
            <div style={{ marginTop: 4, color: "#444", fontSize: 13 }}>
              <b>Please Note</b>: You can select <strong>{chosenPlan.remainingToMax}</strong> more topic{chosenPlan.remainingToMax > 1 ? "s" : ""} to reach this plan's maximum ({chosenPlan.Maxt}).
            </div>
          )}

          {chosenPlan.remainingToMin > 0 && (
            <div style={{ marginTop: 6, color: "#a66", fontSize: 13 }}>
              <b>Please Note</b>: You need <strong>{chosenPlan.remainingToMin}</strong> more topic{chosenPlan.remainingToMin > 1 ? "s" : ""} to reach the minimum required ({chosenPlan.Mint}) for this plan.
            </div>
          )}
        </div>
       <button
  type="button"
  onClick={handleBook}
  disabled={!canProceed}
  aria-disabled={!canProceed}
  style={{
    padding: "12px 31px",
    border: "1px solid #14a077",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "26px",
    borderRadius: "4px",
    display: "block",
    color: "rgb(255, 255, 255)",
    backgroundColor: (!canProceed) ? "#9fcfba" : "#14a077",
    textTransform: "none",
    marginTop: "15px",
    width: "100%",
    cursor: (!canProceed) ? "not-allowed" : "pointer",
    opacity: (!canProceed) ? 0.7 : 1,
  }}
>
  {bookingLoading ? "Please Wait…" : "Next: Select a Time Slot"}
</button>
      </div>

    </div>
  </div>
)}
                  <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>
                    Astrology Topics
                    <br />
                    <span style={{ fontWeight: "normal", fontSize: "13px" }}>Kindly Choose eConsultation Topics You Are interested in</span>
                  </p>

                  {/* Inline user note about limits */}
                  {globalMax > 0 && selectedCount > 0 && (
                    <div style={{ marginTop: 0, color: isGlobalMaxReached ? "#9b2c2c" : "#666", fontSize: 14, marginBottom: 10 }}>
                      {isGlobalMaxReached ? (
                        <strong>You have reached the maximum ({globalMax}) topics allowed by available astrologer plans.</strong>
                      ) : (
                        <span style={{fontWeight:"bold"}}>
                          <span style={{color: "#14a077"}}>Selected Topics</span>: <strong>{selectedCount}</strong>
                        </span>
                      )}
                    </div>
                  )}
<style>{`
  .switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #ccc;
  transition: 0.3s;
  border-radius: 34px;
}

.slider:before {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  left: 3px;
  bottom: 3px;
  background: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background: #0d6efd;
}

input:checked + .slider:before {
  transform: translateX(24px);
}
`}</style>
                 <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
    marginTop: "10px",
    fontWeight: "bold",
    fontSize: "15px",
  }}
>
  <span>English</span>

  <label className="switch">
    <input
      type="checkbox"
      checked={language === "hi"}
      onChange={(e) => setLanguage(e.target.checked ? "hi" : "en")}
    />
    <span className="slider"></span>
  </label>

  <span>हिन्दी</span>
</div>

                  <div style={{ overflowX: "auto" }}>

                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        border: "1px solid #ddd",
                        marginBottom: "20px",
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: "#f8f8f8" }}>
                          <th style={{ padding: "8px", borderBottom: "1px solid #ddd", textAlign: "center" }}>
                            <input
                              type="checkbox"
                              checked={selectedTopics.length === topics.length || (globalMax > 0 && selectedTopics.length === Math.min(topics.length, globalMax))}
                              onChange={handleSelectAll}
                            />
                          </th>
                          <th style={{ textAlign: "left", padding: "10px", fontWeight: "600" }}>
  {language === "hi" ? "ज्योतिष विषय" : "Astrology Topics"}
</th>

<th style={{ textAlign: "left", padding: "10px", fontWeight: "600" }}>
  {language === "hi" ? "संक्षिप्त विवरण" : "Quick Description"}
</th>
                        </tr>
                      </thead>
                      <tbody>
                        {topics.map((topic) => {
                          const disabled = isGlobalMaxReached && !selectedTopics.includes(topic.Id);
                          return (
                            <tr key={topic.Id} style={{ borderBottom: "1px solid #eee" }}>
                              <td style={{ padding: "8px", textAlign: "center" }}>
                                <input
                                  type="checkbox"
                                  checked={selectedTopics.includes(topic.Id)}
                                  onChange={() => handleSelect(topic.Id)}
                                  disabled={disabled}
                                  title={disabled ? `You cannot select more than ${globalMax} topics` : undefined}
                                />
                              </td>
                              <td style={{ padding: "8px", fontWeight: "600" }}>{language === "hi" ? topic.Named2 : topic.Named}</td>
                              <td style={{ padding: "8px", color: "#555" }}>{language === "hi"
  ? (topic.Qdesc2 || "विवरण उपलब्ध नहीं है")
  : (topic.Qdesc || "No description available")}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                  </div>

                </div>

                <div className="col-lg-4 col-md-4 col-12">
                  <p style={{ marginBottom: "12px", fontWeight: "bold", fontSize: "16px" }}>
                    Available Astrologer Plans
                    <br />
                    <span style={{ fontWeight: "normal", fontSize: "13px" }}>Plans get automatically managed based on topics selected.</span>
                  </p>

                  <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", justifyContent: "flex-start" }}>
                    {plansWithRemaining.map((item) => {
                      const isAuto = item.isAutoSelected;
                      return (
                        <div
                          key={item.planId}
                          style={{
                            width: "100%",
                            borderRadius: "12px",
                            background: isAuto ? "#f6fffb" : "#fff",
                            border: isAuto ? "1px solid #bfead2" : "1px solid #e6e6e6",
                            padding: "16px",
                            boxShadow: isAuto ? "0 6px 18px rgba(20,160,119,0.06)" : "0 4px 12px rgba(0,0,0,0.05)",
                            transition: "transform 0.2s ease",
                          }}
                        >
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
                            <div>
                              <h6 style={{ fontWeight: "900", marginBottom: "8px" }}>
                                Plan {item.totalPrice}
                              </h6>
                              <p style={{ margin: "4px 0", color: "#555" }}>
                                <strong>Max. Topics covered:</strong> {item.Maxt ?? "N/A"}
                              </p>
                            </div>

                            {isAuto && (
                              <div style={{ textAlign: "right" }}>
                                <div style={{ background: "#14a077", color: "white", padding: "4px 8px", borderRadius: 6, fontSize: 12, fontWeight: 700 }}>
                                  Auto-selected
                                </div>
                              </div>
                            )}
                          </div>

                          <div style={{ marginTop: 8 }}>
                            <p style={{ margin: "10px 0 0", color: "#14a077", fontWeight: "bold", fontSize: "18px" }}>
                              Total: ₹{Number(item.totalPrice ?? 0).toFixed(2)}
                              <br />
                              <span style={{ color: "black", fontSize: "13px", fontWeight: 500 }}>(Inclusive Of All Taxes)</span>
                            </p>

                            {/* Remaining notes */}
                            {isAuto && item.remainingToMax > 0 && (
                              <p style={{ marginTop: 8, color: "#555", fontSize: 13 }}>
                                <b>Please Note</b>: You can select <strong>{item.remainingToMax}</strong> more topic{item.remainingToMax > 1 ? "s" : ""} to reach this plan's maximum ({item.Maxt}).
                              </p>
                            )}
                            {isAuto && item.remainingToMin > 0 && (
                              <p style={{ marginTop: 8, color: "#a66", fontSize: 13 }}>
                                <b>Please Note</b>: You need <strong>{item.remainingToMin}</strong> more topic{item.remainingToMin > 1 ? "s" : ""} to reach this plan's minimum ({item.Mint}).
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                 <button
  type="button"
  onClick={handleBook}
  disabled={!canProceed}
  aria-disabled={!canProceed}
  style={{
    padding: "12px 31px",
    border: "1px solid #14a077",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "26px",
    borderRadius: "4px",
    display: "block",
    color: "rgb(255, 255, 255)",
    backgroundColor: (!canProceed) ? "#9fcfba" : "#14a077",
    textTransform: "none",
    marginTop: "15px",
    width: "100%",
    cursor: (!canProceed) ? "not-allowed" : "pointer",
    opacity: (!canProceed) ? 0.7 : 1,
  }}
>
  {bookingLoading ? "Please Wait…" : "Next: Select a Time Slot"}
</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
      <Gotop />
    </>
  );
}

export default Planner;